import { TbPlayerPlayFilled } from "solid-icons/tb";
import { Show } from "solid-js";
import { VIDEOS } from "~/components/marketing/content";
import { offerFlowDemo, smartTagsDemo } from "~/components/marketing/demo";
import { OfferFlowMockup, SmartTagsMockup } from "~/components/marketing/mockups";
import { useMarketingVideo, VideoSlot } from "~/components/marketing/video";
import { useI18n } from "~/i18n";

/** Two Live Sessions: the offer flow in front, Notes behind. The demo plays in front of both. */
export const HeroVisual = () => {
  const { t } = useI18n();
  const video = useMarketingVideo();
  return (
    <div class="relative sm:pb-[11%]">
      <SmartTagsMockup data={smartTagsDemo(t)} class="hidden w-[64%] sm:block [&_.mk-frame]:shadow-black/25" />
      <OfferFlowMockup data={offerFlowDemo(t)} class="sm:absolute sm:inset-e-[4%] sm:bottom-0 sm:w-[64%]" />
      {/* From lg up the card centres in the free corner under the back mockup: 36% wide, as tall as the 11% padding. Narrower, the corner is too small for it. */}
      <div class="mt-6 flex items-center justify-center lg:absolute lg:inset-s-0 lg:bottom-0 lg:mt-0 lg:aspect-36/11 lg:w-[36%]">
        <WatchDemo onClick={() => video.play("exec-demo")} />
      </div>
      <Show when={video.active()?.id === "exec-demo"}>
        <VideoSlot id="exec-demo" class="absolute inset-x-0 top-1/2 mx-auto w-[84%] max-w-4xl -translate-y-1/2" />
      </Show>
    </div>
  );
};

const WatchDemo = (props: { onClick: () => void }) => {
  const { t } = useI18n();
  return (
    <button
      type="button"
      onClick={() => props.onClick()}
      class="group flex cursor-pointer items-center gap-4 rounded-2xl border border-primary-border bg-tile p-2 pe-6 text-start shadow-xl shadow-black/5 transition-colors hover:border-brand-border focus-visible:ring-2 focus-visible:ring-brand focus-visible:outline-none"
    >
      <span class="relative block aspect-16/10 w-32 shrink-0 overflow-hidden rounded-xl bg-panel">
        <img
          src={VIDEOS["exec-demo"].poster}
          alt=""
          width="640"
          height="448"
          loading="lazy"
          class="size-full object-cover transition-transform duration-300 group-hover:scale-105"
        />
        <span class="absolute inset-0 grid place-items-center bg-black/15">
          <span class="grid size-9 place-items-center rounded-full bg-white/95 text-brand shadow-md transition-transform group-hover:scale-110">
            <TbPlayerPlayFilled class="size-4 translate-x-px" aria-hidden="true" />
          </span>
        </span>
      </span>
      <span class="flex flex-col gap-0.5">
        <span class="text-base font-semibold text-primary-text">{t("marketing.home.hero.watch_demo")}</span>
        <span class="text-sm text-secondary-text tabular-nums">{VIDEOS["exec-demo"].duration}</span>
      </span>
    </button>
  );
};
